export function set(key, val) {
  return localStorage.setItem(key, JSON.stringify(val))
}
export function get(key) {
  return localStorage.getItem(key)

}
export function remove(key) {
  return localStorage.removeItem(key)

}